<template>
  <div class="comment-page">
    <div class="comment-top">
      <img :src="commentfather.topic.picUrl" alt="">
      <!-- <div> -->
      <div class="comment-title">{{commentfather.topic.title}}</div>
      <!-- <div>{{commentfather.topic.title}}</div> -->
      <!-- </div> -->
    </div>
    <div class="score">
      <div class="score-title">您对商家/商品满意吗？</div>
      <div class="line"></div>
      <div class="rate-content">
        评分
        <van-rate v-model="value" @change="rateChange" />
        <span class="rate-text"> {{rateText}}</span>

      </div>

    </div>
    <div class="text-area">
      <van-field style="height:10.6rem" v-model="message" rows="2" autosize type="textarea" placeholder="留言经过筛选后，对所有人可见" show-word-limit />

    </div>
    <div class="upload-content">
      <van-uploader @delete="deleteEvent" v-model="fileList" multiple />

    </div>
    <div class="limit">最多上传9张</div>

    <div class="btn-box">
      <div class="sub-btn" @click="postComment">发表</div>

    </div>
  </div>
</template>

<script>
// import itemInfo from "@/components/itemInfo";

import { commentPost, batchUpload } from "@/api/index";
import { Toast, Dialog } from "vant";
// import { Toast } from "vant";

export default {
  name: "commentPage",
  data() {
    return {
      value: 5,
      rateText: "十分满意",
      message: "",
      fileList: [],
      commentfather: JSON.parse(this.$route.query.info),
      commentData: {
        type: "", //类型
        valueId: "", //专题id
        content: "", //评论内容
        star: 1, //星数
        hasPicture: false,
        picUrls: []
      },
      hasPicList: false,
      picUrlList: []
    };
  },
  methods: {
    rateChange(rate) {
      console.log(rate);
      switch (rate) {
        case 1:
          this.rateText = "很差";
          break;
        case 2:
          this.rateText = "不太满意";

          break;
        case 3:
          this.rateText = "满意";

          break;
        case 4:
          this.rateText = "比较满意";

          break;
        default:
          this.rateText = "十分满意";

          break;
      }
    },
    deleteEvent(file, idx) {
      console.log(idx.index);
      this.commentData.picUrls.splice(idx.index, 1);
    },
    postComment() {
      let that = this;
      if (this.message == "" && this.message.length == undefined) {
        Toast("内容不能为空");
        return;
      }

      if (this.fileList.length == 0) {
        that.commentData.type = 1;
        that.commentData.valueId = that.commentfather.topic.id;

        that.commentData.content = that.message;

        that.commentData.star = that.value;
        that.commentData.hasPicture = false;

        that.commentData.picUrls = [];
        commentPost(that.commentData).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            Toast("评论成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 800);
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.errmsg
            });
          }
        });
      } else {
        var param = new FormData(); // FormData 对象
        this.fileList.forEach(item => {
          console.log(item);
          param.append("files", item.file); // 文件对象
        });

        batchUpload(param).then(res => {
          if (res.data.errno == 413) {
            Dialog.alert({
              title: "提示",
              message: "图片过大，请重新选择上传"
            });
          }

          if (res.data.errno != 0) return;
          console.log(res);
          this.commentData.picUrls = res.data.data.url;
          this.commentData.type = 1;
          this.commentData.valueId = this.commentfather.topic.id;

          this.commentData.content = this.message;

          this.commentData.star = this.value;
          this.commentData.hasPicture = true;
          commentPost(this.commentData).then(respo => {
            console.log(respo);
            this.hasPicList = false;
            if (respo.data.errno == 0) {
              this.$router.go(-1);
            } else {
              Dialog.alert({
                title: "提示",
                message: respo.data.errmsg
              });
            }
          });
        });

        // });
      }
    }
  },
  // watch: {
  //   hasPicList(oldV, newV) {
  //     console.log(newV);
  //     if (oldV) {
  //       console.log(this.picUrlList);
  //       this.commentData.type = 1;
  //       this.commentData.valueId = this.commentfather.topic.id;

  //       this.commentData.content = this.message;

  //       this.commentData.star = this.value;
  //       this.commentData.hasPicture = true;

  //       this.commentData.picUrls = this.picUrlList;
  //       commentPost(this.commentData).then(respo => {
  //         console.log(respo);
  //         this.hasPicList = false;
  //         if (respo.data.errno == 0) {
  //           this.$router.go(-1);
  //         } else {
  //           Dialog.alert({
  //             title: "提示",
  //             message: respo.data.errmsg
  //           });
  //         }
  //       });
  //     }
  //   }
  // },
  created() {
    this.commentfather = JSON.parse(this.$route.query.info);
  }
};
</script>

<style lang="scss" scoped>
.comment-page {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  // padding-bottom: 5rem;
  box-sizing: border-box;
  overflow-x: hidden;
  .comment-top {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    height: 5rem;
    margin-bottom: 1rem;

    img {
      width: 3.4rem;
      height: 3.4rem;
      margin: 0 0.8rem 0 1.2rem;
    }
    .comment-title {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
    }
  }
  .score {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    // padding-left: 1.6rem;
    padding: 1.6rem;
    box-sizing: border-box;
    background: #fff;
    .score-title {
      font-family: PingFangSC-Semibold;
      font-size: 1.6rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.8rem;
      text-align: left;
      width: 100%;
    }
    .line {
      opacity: 0.3;
      border-top: 1px solid #c2c2c2;
      width: 100%;
      margin: 1.25rem auto 1.64rem;
    }
    .rate-content {
      font-family: PingFangSC-Semibold;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      /deep/ .van-rate {
        margin: 0 1.6rem;
      }
      .rate-text {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.2rem;
      }
    }
  }
  .text-area {
    // border: 0.3rem solid #eee;
    width: 100%;
    background: #fff;
    // margin: 1rem auto;
    /deep/ .van-cell__value--alone {
      background: #fafafa;
      border: 0 solid rgba(66, 66, 66, 0.1);
      padding-left: 1.2rem;
      padding-top: 1.2rem;
    }
  }
  .upload-content {
    width: 100%;
    background: #fff;
    .van-uploader {
      padding-left: 2rem;
      display: block;
    }
  }
  .limit {
    width: 100%;
    padding-right: 1.2rem;
    box-sizing: border-box;
    text-align: right;
    background: #fff;
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #424242;
    letter-spacing: 0;
    text-align: right;
    line-height: 1.2rem;
    padding-bottom: 1.2rem;
  }
  .img-upload {
    font-size: 1.4rem;
    text-align: left;
    padding-left: 2rem;
    color: #999;
    margin: 2rem 0;
  }

  .btn-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    background: #fff;
    height: 8.8rem;
    position: fixed;
    padding-top: 0.8rem;
    box-sizing: border-box;
    bottom: 0;
    .sub-btn {
      background: #d6be93;
      border-radius: 24px;
      height: 4rem;
      width: 89.3%;
      font-family: PingFangSC-Regular;
      font-size: 1.6rem;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index/commentPage.vue